<template>
  <v-container
    id="about"
    fluid
    class="py-16"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
      >
        <div class="app-fade-in-section">
          <v-card>
            <v-card-text class="pa-8">
              <h2 class="text-h5 text-sm-h4 text-md-h3 font-weight-bold text-center mb-6">
                For Developers, By Developers.
              </h2>
              
              <div class="content-with-floating-image">
                <div class="floating-image">
                  <v-img
                    :src="programmerDuck"
                    alt="Yellow Duck Programmer"
                    max-width="320"
                    class="rounded-xl"
                    contain
                    loading="lazy"
                  />
                </div>
                
                <div class="flowing-text">
                  <p class="text-responsive mb-4">
                    Yellow Duck was founded by, is run by, and is designed for
                    software developers. Our philosophy is simple:
                    <strong>people over process</strong>,
                    <strong>results over rituals</strong>, and <strong>delivering
                      value over checking boxes</strong>. We
                    specialize in technical mentoring and assembling elite
                    software teams to engineer the most robust and powerful solutions.
                  </p>
                  <p class="text-responsive">
                    Our focus isn't just on delivering code; it's on building
                    cohesive units that drive mission success through
                    collaboration, innovation, and deep technical expertise. By
                    prioritizing our people, we ensure our partners get the
                    best-in-class talent required to achieve their objectives.
                  </p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import programmerDuck from "@/assets/hacker_duck.webp";
</script>

<script>
export default {
  name: "AboutUsSection",
};
</script>

<style scoped>
.content-with-floating-image {
  position: relative;
  overflow: visible;
  min-height: 400px; /* Ensure container is tall enough for image */
}

/* Add clearfix to contain floats properly */
.content-with-floating-image::after {
  content: "";
  display: table;
  clear: both;
}

.floating-image {
  float: right;
  margin: 0 0 1.5rem 2rem;
  shape-outside: margin-box;
  width: 320px;
  max-width: 40%; /* Ensure it doesn't take too much space */
  display: flex;
  align-items: flex-start;
}

.floating-image :deep(.v-img__image) {
  background-position: center top !important; /* Ensure image starts from top */
}

.flowing-text {
  text-align: justify;
  line-height: 1.7;
}

.flowing-text p {
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .floating-image {
    float: right;
    margin: 0 0 1rem 1rem;
    width: 150px;
    max-width: 40%;
  }

  .floating-image .v-img {
    max-width: 150px;
  }

  .flowing-text {
    text-align: left;
  }
}

@media (max-width: 960px) and (min-width: 769px) {
  .floating-image {
    width: 240px;
    margin-left: 1.5rem;
  }
}
</style>
